import type { FC } from 'react';
import { BatchAction } from '../../../../types/store';
import SelectionArea from '../../_partials/SelectionArea';
import BatchEditOrDeleteConfirmation from '../../../../modals/BatchEditOrDeleteConfirmation';
import TitleBatchEdit from '../../../batchActions/TitleBatchEdit';
import TagsBatchEdit from '../../../batchActions/TagsBatchEdit';
import DescriptionBatchEdit from '../../../batchActions/DescriptionBatchEdit';
import GalleryBatchEdit from '../../../batchActions/GalleryBatchEdit';
import TierBatchEdit from '../../../batchActions/TierBatchEdit';
import LabelsBatchEdit from '../../../batchActions/LabelsBatchEdit';
import LicenseBatchEdit from '../../../batchActions/LicenseBatchEdit';
import CommentsBatchEdit from '../../../batchActions/CommentsBatchEdit';
import ScheduleBatch from '../../../batchActions/ScheduleBatch';
import AttributeBatchEdit from '../../../batchActions/AttributeBatchEdit';
import PresetBatchEdit from '../../../batchActions/PresetBatchEdit';
import DefaultBatchEdit from '../../../batchActions/DefaultBatchEdit';
import DisplayOptionsBatchEdit from '../../../batchActions/DisplayOptionsBatchEdit';
import { SelectionProps } from '../../types';

export interface Props extends SelectionProps {
  batchAction: BatchAction;
  batchDoDelete: () => void;
  cancelBatchAction: () => void;
}

const BatchActionLayout: FC<Props> = ({
  batchAction,
  batchDoDelete,
  cancelBatchAction,
  ...selectionProps
}) => {
  const selectionArea = <SelectionArea {...selectionProps} />;
  switch (batchAction) {
    case BatchAction.EDIT_TITLE:
      return <TitleBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_TAGS:
      return <TagsBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_DESCRIPTION:
      return <DescriptionBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_GALLERY:
      return <GalleryBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_TIER:
      return <TierBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_LABELS:
      return <LabelsBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_LICENSE:
      return <LicenseBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_COMMENTS:
      return <CommentsBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_SCHEDULE:
      return <ScheduleBatch selectionArea={selectionArea} />;
    case BatchAction.EDIT_DISPLAY_OPTIONS:
      return <DisplayOptionsBatchEdit selectionArea={selectionArea} />;
    case BatchAction.EDIT_PRESET:
      return <PresetBatchEdit selectionArea={selectionArea} />;
    case BatchAction.BOOL_AI_ADD:
    case BatchAction.BOOL_AI_DEL:
    case BatchAction.BOOL_MATURE_ADD:
    case BatchAction.BOOL_MATURE_DEL:
    case BatchAction.BOOL_NOAI_ADD:
    case BatchAction.BOOL_NOAI_DEL:
      return <AttributeBatchEdit batchAction={batchAction} />;
    case BatchAction.OTHER_DELETE:
      return (
        <BatchEditOrDeleteConfirmation
          isOpen
          selectedCount={selectionProps.selectedCount}
          onConfirm={batchDoDelete}
          onCancel={cancelBatchAction}
          variant="delete"
        />
      );

    default:
      return <DefaultBatchEdit selectionArea={selectionArea} />;
  }
};
BatchActionLayout.displayName = 'BatchActionLayout';

export default BatchActionLayout;
